<template>
  <div v-if="datas && datas.records.length" class="page">
    <div v-for="(item, index) in datas.records" :key="index" class="page-item flex-row-align-center fileResContent" @click="toDetail(item)">

      <div v-if="item.resourceType == 'image'" class="page-item-img radius-clip-5 sourceBox" :style="{backgroundImage: 'url(' + item.resourceCloudUrl + ')','background-position':'center','background-size':'cover'}" />
      <div v-else-if="item.resourceType == 'video'" class="page-item-img radius-clip-5 sourceBox position-relative" :style="{backgroundImage: 'url(' + item.previewUrl + ')','background-position':'center','background-size':'cover'}">
        <div class="mask-bg position-absolute flex-center radius-clip-5">
          <img src="../../../../../assets/icon-resource-video.png" alt="">
        </div>
      </div>
      <div v-else-if="item.resourceType == 'audio'" class="page-item-img radius-clip-5 sourceBox position-relative audio">
        <div class="mask-bg position-absolute flex-center radius-clip-5">
          <img src="../../../../../assets/icon-resource-audio.png" alt="">
        </div>
      </div>
      <div v-else-if="item.resourceType == 'zip'" class="page-item-img radius-clip-5 sourceBox position-relative zip">
        <div class="mask-bg position-absolute flex-center radius-clip-5">
          <img src="../../../../../assets/icon-resource-zip.png" alt="">
        </div>
      </div>
      <div v-else-if="item.resourceType == 'pdf'" class="page-item-img radius-clip-5 sourceBox position-reative pdf">
        <div class="mask-bg position-absolute flex-center radius-clip-5">
          <img src="../../../../../assets/icon-resource-pdf.png" alt="">
        </div>
      </div>
      <div class="flex-column flex-1">
        <div class="page-item-tit cursor">
          <p class="font-size-14 text-line-1" v-html="item.resourceName">/p>
          </p></div>
        <div class="page-item-desc current">
          <p class="font-size-14 text-line-1" v-html="item.description" />
        </div>
        <div class="page-item-mark flex-row-align-center">
          <div class="page-item-mark flex-row-align-center">
            <div class="page-item-mark-item flex-center radius-clip-5">
              <p class="font-size-12 font-color-264480 text-line-1 icontype">馆藏：{{ item.collection.collectionName }} {{ item.collection.subtitle? '-'+item.collection.subtitle:'' }} {{ item.collection.chapter?'-'+item.collection.chapter:'' }}</p>
            </div>
            <div v-if="item.collection.listCategory" class="page-item-mark-item flex-center radius-clip-5">
              <div class=" flex-row-align-center" style="padding: 0 10px;">
                <p class="font-size-12 font-color-264480 text-line-1 ">分类：</p>
                <div class="flex-1 flex">
                  <div v-for="cate in item.collection.listCategory" :key="cate.id" class="data-content-item-info-mark-item-wrap-cate flex flex-row-align-center flex-shrink">
                    <p class="font-size-12 data-content-item-info-mark-item-wrap-text text-line-1" @click.stop="cateToSearch(cate)">{{ cate.cateName }}</p>
                    <p class="font-size-12 font-color-666">/</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="item.collection.subjectList && item.collection.subjectList.length" class="page-item-mark-item flex-center radius-clip-5">
              <div class=" flex-row-align-center" style="padding: 0 10px;">
                <p class="font-size-12 font-color-264480 text-line-1 ">学科：</p>
                <div class="flex-1 flex">
                  <div v-for="cate in item.collection.subjectList" :key="cate.id" class="data-content-item-info-mark-item-wrap-cate flex flex-row-align-center flex-shrink">
                    <p class="font-size-12 data-content-item-info-mark-item-wrap-text text-line-1" @click.stop="subjectToSearch(cate)">{{ cate.subjectName }}</p>
                    <p class="font-size-12 font-color-666">/</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="item.submitternName" class="page-item-mark-item flex-center radius-clip-5 cursor">
              <p class="font-size-12 font-color-264480 text-line-1 icontype" @click.stop="pubmanToSearch(item)">发布：{{ item.submitternName }} </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="user-empty flex flex-center mach-width">
    <p class=" font-size-14 font-color-666">暂无内容</p>
  </div>
</template>

<script>
import user from '../../../../../models/user.js'
export default {
  props: {
    datas: {
      type: Object,
      default: null
    }
  },
  watch: {
    datas() {
      console.log(this.datas)
    }
  },
  data(){
      return{
        // loading: true
      }
     
    },
  methods: {
    loadData(v) {
      this.datas = v
    },
    cateToSearch(v) {
      this.$emit('params', { params: { attributionType: v.id }, display: v.cateName, type: 'attributionType' })
    },
    subjectToSearch(v) {
      this.$emit('params', { params: { subject: v.id }, display: v.subjectName, type: 'subject' })
    },
    pubmanToSearch(v) {
      this.$emit('params', { params: { commitBy: v.createUser }, display: v.submitternName, type: 'commitBy' })
    },
    toDetail(v) {
      const routeData = this.$router.resolve({
        name: 'Resource',
        query: {
          rsId: v.collection.id,
          fId: v.id,
          permission: v.permissionRange
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style scoped>
.page-item {
  width: 100%;
  height: 140px;
}

.page-item-img {
  width: 120px;
  height: 80px;
  margin-right: 20px;
  cursor: pointer;
}

.audio {
  background-color: #00C5E5;
}

.pdf {
  background-color: #FF527B;
}

.zip {
  background-color: #525966;
}

.page-item-tit {
  width: 100%;
  height: 24px;
}

.page-item-mark {
  margin-top: 10px;
  height: 24px;
}

.page-item-mark-item {
  padding: 4px 8px;
  margin-right: 10px;
  max-width: 180px;
  margin-right: 10px;
  background: #F3F4F9;
  height: 24px;
}
.page-item-mark-item:last-child {
  margin: 0;
}
.fileResContent .sourceBox{
  margin-right: 20px;
}
.fileResContent .page-item-desc{
  color:#666;
  margin-bottom: 10px;
  letter-spacing: .5px;
}
.fileResContent .icontype{
  padding:0 10px;
  line-height: 24px;
}
.mask-bg {
  background-color: rgba(0, 0, 0, 0.3);
  width: 120px;
  height: 80px;
}
.user-empty{
  height: 400px;
}

.data-content-item-info-mark-item-wrap-text {
    cursor: pointer;
    color: #264480;
    text-decoration: underline;
  }

  .data-content-item-info-mark-item-wrap-cate {
    max-width: 60px;
    overflow: hidden;
  }
  .data-content-item-info-mark-item-wrap-cate:last-child p:last-child {
    display: none;
  }
</style>
